import "amazon-connect-streams"

const connectBundle = {
    connect
};
export default connectBundle